import type { ChartDatapoint } from '../../core/types/chart-data.js';

/**
 * Returns a shallow copy of `record` with all `__`-prefixed keys removed.
 * Used to strip D3-internal geometry fields before exposing datapoints to consumers.
 */
export function stripPrivateFields(
  record: Record<string, unknown>,
): ChartDatapoint {
  const result: ChartDatapoint = {};
  for (const key of Object.keys(record)) {
    if (!key.startsWith('__')) {
      result[key] = record[key];
    }
  }
  return result;
}
